import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import * as XLSX from "xlsx";
import SystemModal from "../../Common/SystemModal";
import Loader from "../../Common/Loader";
import ajaxAccounting from "../../../util/remote/ajaxAccounting";
import jsPDF from "jspdf";

const InvoicesExportPdf = (props) => {
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [ExportData, setExportData] = useState([]);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setToDate(today);
  }, []);

  // Function to handle footer rendering
  const RenderFooter = (controls) => {
    if (loading) {
      return <Loader />;
    } else {
      return (
        <>
          <button
            className="btn ripple btn-dark"
            type="button"
            onClick={controls.close}
          >
            Close
          </button>
          <button
            type="button"
            disabled={loading}
            className={`btn ripple btn-success`}
            onClick={() => fetchExportData(controls)}
          >
            Export
          </button>
        </>
      );
    }
  };

  // Function to get payment vouchers
  const fetchExportData = async () => {
    if (!fromDate || !toDate) {
      toast.error("Please fill in both From Date and To Date.");
      return;
    }
    const data = {
      projectID: props.projectID,
      clientID: props.clientID,
      start_date: fromDate,
      to_date: toDate,
    };
    setExportData([]);
    setLoading(true);

    const server_response = await ajaxAccounting.getInvoicesForExport(data);
    setLoading(false);
    if (server_response.status === "OK") {
      setExportData(server_response.details);
    } else {
      toast.error("No data available for export");
    }
  };
  useEffect(() => {
    if (ExportData.length > 0) {
      exportToPDF();
    }
  }, [ExportData]);
  // Function to export data to Excel

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const companyName = "BERICOT AFRICA LIMITED";
    const companyAddress = "KAMPALA UGANDA \n TEL:+256701666160";
    const currentDate = `Date of Printing: ${new Date().toLocaleDateString()}`;
    const headerDescription = `Invoice_transactions_ from ${fromDate} to ${toDate}`;
    // Get the PDF page width for centering the text
    const pageWidth = pdf.internal.pageSize.getWidth();

    // Add company name
    pdf.setFontSize(14);
    const companyNameWidth = pdf.getTextWidth(companyName);
    pdf.text(companyName, (pageWidth - companyNameWidth) / 2, 50);

    // Add company address
    pdf.setFontSize(12);
    const companyAddressWidth = pdf.getTextWidth(companyAddress.split("\n")[0]);
    pdf.text(
      companyAddress.split("\n")[0],
      (pageWidth - companyAddressWidth) / 2,
      80
    );
    const companyAddressCityWidth = pdf.getTextWidth(
      companyAddress.split("\n")[1]
    );
    pdf.text(
      companyAddress.split("\n")[1],
      (pageWidth - companyAddressCityWidth) / 2,
      100
    );

    // Add printing date
    pdf.setFontSize(9);
    const dateWidth = pdf.getTextWidth(currentDate);
    pdf.text(currentDate, (pageWidth - dateWidth) / 2, 130);

    // Add header description
    pdf.setFontSize(12);
    const headerDescriptionWidth = pdf.getTextWidth(headerDescription);
    pdf.text(headerDescription, (pageWidth - headerDescriptionWidth) / 2, 160);

    // Define columns for the table
    const columns = [
      "No.",
      "Reference",
      "Client",
      "project_name",
      "lpo_no",
      "ref_no",
      "amount_crude",
      "vat",
      "Total_Amount",
      "amount_due",
      "Date",
      "Reciever",
      "Created_by",
    ];

    let data = [];

    if (Array.isArray(ExportData)) {
      data = ExportData.map((item, key) => [
        key + 1,

        item.Invo_no,
        item.client_name,
        item.project_name,
        item.lpo_no,
        item.ref_no,
        item.ref_no,
        item.amount_crude.amount_crude_c,
        item.vat.vat_c,
        item.Amount_vated.Amount_vated_c,
        item.amount_due.amount_due_c,
        item.date.short_date,
        item.reciever,
        item.created_by.name,
      ]);
    }

    // Add the table to the PDF
    pdf.autoTable({
      startY: 180,
      head: [columns],
      body: data,
    });

    // Save the PDF
    pdf.save(`Payment_voucher_trans_from_${fromDate}_to ${toDate}.pdf`);
  };

  // Event handler for export button

  return (
    <SystemModal title="" id="model-new-ledger" size="lg" footer={RenderFooter}>
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                className="card custom-card"
                style={{ borderRadius: "10px" }}
              >
                <div className="card-body">
                  <div>
                    <h6 className="card-title mb-4">
                      Invoices Transactions Exporting To PDF
                    </h6>
                  </div>

                  <form method="">
                    <div className="row">
                      <div className="mb-4 col-md-6">
                        <label htmlFor="">
                          From Date
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="mb-4 col-md-6">
                        <label htmlFor="">
                          To Date
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

export default InvoicesExportPdf;
